export const SET_PRODUCTS = 'products/SET_PRODUCTS';
export const SET_PRODUCTS_CLEANUP = 'products/SET_PRODUCTS_CLEANUP';
